import { Box, Grid, FormControl,FormLabel } from "@mui/material";
import { useCallback } from 'react';
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../bmr/components/common/FormikControl";
import { useDispatch, useSelector } from "react-redux";
import { addPaymentStatusValidationSchema } from "../../../utils/formik/validationSchema"
import { modeOfPaymentStatus } from "../../../bmr/slices/help"
import {SUPPORTED_FORMATS} from "../../../pages/appointment-details/common-pre-screen/common"
import {handleDownload} from "../../../bmr/constants/constant"
import  FileUploadComponent from '../../../bmr/pages/FeasibilityAssessment/BMRSlots/FileUploadComponent'
import { selectDropDownDataMaster, fetchManufecturingButtonDropDown } from "../../../bmr/slices/customMaster"
import { useEffect } from "react";

const AddUpdatePayment = ({ editData={}, feasiblityId, handleCloseModal={} }) => {
    const dispatch = useDispatch()
    const PaymentStatusList = useSelector(selectDropDownDataMaster('payment'))
    
    useEffect(() => {
        dispatch(fetchManufecturingButtonDropDown('payment'))
    },[])

      const initialValue  =   {
        payment_status: editData?.payment_status ? PaymentStatusList?.find((it)=>it?.label?.toLocaleLowerCase() == editData?.payment_status?.toLocaleLowerCase())?.value : '',
        media: editData?.payment_media ?? [],
        media_id : editData?.payment_media?.length > 0 ? editData?.payment_media?.map((it)=>it?.id):[],
        remarks: editData?.remarks  ?? '',
      }

      const handleModelSubmit = useCallback(async(values) => {
              try {
                        const data = {
                            id: feasiblityId,
                            data: values
                        }
                        const res = await dispatch(modeOfPaymentStatus(data))
                        if(modeOfPaymentStatus?.fulfilled?.match(res)){
                           handleCloseModal()
                        }
                    } catch (err) {
                        console.error(err);
                    }
            },[])

    
    const formik = useFormik({
        initialValues:initialValue,
       validationSchema:addPaymentStatusValidationSchema,
        onSubmit:handleModelSubmit,
        enableReinitialize: true
    })

   const formOptions = [
  {
    type: "select",
    name: "payment_status",
    label: "Payment Status",
    placeholder:"Select Payment Status",
    options: PaymentStatusList,
    required: true
  },
{
    label: "Select Attachment",
    type: "file",
    name: "media_id",
    multiple: true,
    removeButton: false,
    acceptFormat: SUPPORTED_FORMATS,
    downloadFile: handleDownload,
    placeholder: "Select a File",
    required: false,
    col: 1,
},
{
    type: "textarea",
    name: "remarks",
    label: "Remarks",
    placeholder: "Enter Remarks",
    required: true,
}
];

    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                    {formOptions.map((props, key) => (
                        <Grid key={key} item xs={12}>
                               {props?.type === 'file' ? (
                                            <FormControl variant="standard" fullWidth>
                                                <FormLabel shrink required={props.required} className="text-black">
                                                  {props.label}
                                                </FormLabel>
                                                 <FileUploadComponent 
                                                field={props}
                                                value={formik?.values[props.name]}
                                                 formData={{media: formik.values?.media,media_id: formik.values?.media_id }}   // MUST be an object
                                                 setFormData={(cb) => {
                                                    const newState = cb({ media_id: formik.values[props.name] });
                                                    formik.setFieldValue(props.name, newState.media_id);
                                                }}
                                                error={formik?.errors[props.name]}
                                                touched={formik?.touched[props.name]}
                                              />
                                            </FormControl>):
                            <FormikControl formik={formik} {...props} />}
                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={2} className="mt-3">
                    <Grid item xs={12}>
                        <LoadingButton  fullWidth type="submit" variant="contained">{editData ? "Update" : "Submit"}</LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}

export default AddUpdatePayment;